module.exports = __webpack_public_path__ + "static/media/event1.8f499ba0.jpeg";